import React, { useState, useEffect } from "react";
import RequestForReassignModal from "./RequestForReassignModal";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import parse from "html-react-parser";
import "bootstrap/dist/css/bootstrap.min.css";
import Spinner from "react-bootstrap/Spinner";
import {
  checkEmptyString,
  formatDateTimeFormat,
} from "../../helpers/commonHelpers";
import { logOut } from "../../redux/actions/authActions/authAction";
import IsCompleteModal from "./IsCompleteModal";
import { decryptWithAES } from "../../helpers/commonHelpers";
import ActionDropDownNew from "./ActionDropDownNew";
import ReopenActionModal from "../Action/ReopenActionModal";
import { processReassign ,getactionActivitiesDetails} from "../../redux/actions/actionAction/ActionAction";
import CommonModal from "../Common/CommonModal";
import {
  processRequestForReassign,
  updateIsComplete,
  cancelActionForActionDetails,
  fetchSingleAction,
  setIsCheckRequired,
} from "../../redux/actions/actionAction/ActionAction";
import ReassignModal from "./ReassignModal";

const ViewActionDetails = React.memo((props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const actionData = useSelector((state) => state.action);
  const employeeData = useSelector((state) => state.user);
  const meetingData = useSelector((state) => state.meeting);
  const [isRequestForReassignModalOpen, setIsRequestForReassignModalOpen] =
    useState(false);
  const [isCompleteModalOpen, setIsCompleteModalOpen] = useState(false);
  const [actionId, setActionId] = useState(null);
  const [minuteDetails, setMinuteDetails] = useState(null);
  const minute = actionData?.singleActionDetails;
  const [actionDatas, setActionDatas] = useState(null);
  const [isReopenMinuteModal, setIsReopenMinuteModal] = useState(false);
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }

  useEffect(() => {
    document.title = "View Action Details: MinutesVault";

    if (actionData.isSuccess) {
      // setIsCompleteModalOpen(false);
      setIsSuccess(false);
      setIsRequestForReassignModalOpen(false);
    }
    return () => {};
  }, [
    actionData?.singleActionDetails?.isComplete,
    actionData.isSuccess,
    actionData.isFetchedActionList,
    authData?.isInValidUser,
  ]);
  
  useEffect(() => {
    //  alert(0)
    if (
      employeeData?.userData?.organizationId &&
      actionData?.singleActionDetails?.organizationId
    ) {
      //  alert(1)
      if (
        employeeData?.userData?.organizationId !==
          actionData?.singleActionDetails?.organizationId &&
        actionData?.isCheckRequired
      ) {
        // alert(2)

        navigate("/pagenotfound");
      }
    }
  }, [
    employeeData?.userData?.organizationId,
    actionData?.singleActionDetails?.organizationId,
    actionData?.isCheckRequired,
  ]);

  // const handleRequestForReassign = (reason) => {
  //   dispatch(
  //     processRequestForReassign(
  //       actionId,
  //       {
  //         requestDetails: reason,
  //         assignedUsers: actionData?.singleActionDetails?.assignedUserDetail,
  //       },
  //       accessToken
  //     )
  //   );
  //   setActionId(null);
  //   setIsRequestForReassignModalOpen(false);
  // };

  // const handleUpdateIsComplete = (comment) => {
  //   dispatch(
  //     updateIsComplete(
  //       props.actionId,
  //       { isComplete: !actionData?.singleActionDetails?.isComplete, comment },
  //       accessToken
  //     )
  //   );
  //   setActionId(null);
  // };
  const handleUpdateIsComplete = async (comment) => {
    try {
      setIsCompleteModalOpen(true);
      const res = await dispatch(
        updateIsComplete(
          props.actionId,
          { isComplete: !actionData?.singleActionDetails?.isComplete, comment },
          accessToken
        )
      );
      if (res?.success) {
        setIsCompleteModalOpen(false);
        setActionId(null);
      }
    } catch (error) {
      console.error("Update failed", error);
    }
  };

  const handleRequestForReassignModal = (actionId) => {
    setActionId(actionId);
    setIsRequestForReassignModalOpen(true);
  };

  const checkHandler = (actionId) => {
    setActionId(actionId);
    setIsCompleteModalOpen(true);
  };

  const isUserFind =
    actionData?.singleActionDetails?.reassigneRequestDetails?.filter(
      (user) =>
        user?.userId?.toString() === employeeData?.userData?._id?.toString()
    );

  const isMeetingOrganiser =
    actionData?.singleActionDetails?.meetingDetail?.createdById?.toString() ===
    employeeData?.userData?._id?.toString()
      ? true
      : false;
  const currentUserId = employeeData?.userData?._id?.toString();
  const reassignedUserIds =
    actionData?.singleActionDetails?.reassigneRequestDetails
      ?.filter((item) => item?.isRejected === false)
      ?.map((item) => item?.userId?.toString()) || [];

  const isRejectedUser = reassignedUserIds.includes(currentUserId);

  const handleReopenActionModal = (status, minute) => {
    // alert("IN reopen Action")
    minute["modalStatus"] = "REOPEN";
    // dispatch(setSuccess(false));
    setMinuteDetails(actionData?.singleActionDetails);
    setIsReopenMinuteModal(status);
  };

  const handleApproveActionModal = (status, minute) => {
    minute["modalStatus"] = "APPROVE";
    setMinuteDetails(actionData?.singleActionDetails);
    setIsReopenMinuteModal(status);

  };

  const handleCancelAction = (status, minute) => {
    setMinuteDetails(actionData?.singleActionDetails);
    setIsCloseModalOpen(status);
  };

  const handleReassignModal = (action) => {
    setActionId(action._id);
    setActionDatas(action);
    setIsReassignModalOpen(true);
  };

  const handleReassign = (data) => {
    dispatch(
      processReassign(
        actionId,
        {
          organizationId: userData.organizationId,
          assignedUsers: data.assignedUsers,
          reAssignReason: data.reason,
          dueDate: data.date ? data.date : undefined,
          priority: data.priority,
        },
        accessToken
      )
    );
     dispatch(getactionActivitiesDetails(actionId,accessToken));
    setActionId(null);
  };

  const submitCancelAction = async () => {
    const payload = {
      assignedUserDetails: minuteDetails?.assignedUserDetail,
    };
    const result = await dispatch(
      cancelActionForActionDetails(minuteDetails?._id, accessToken, payload)
    );
    if (result.status === true) {
      setIsCloseModalOpen(false);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setIsCheckRequired(false));
    };
  }, []);


  return (
    <>
      <form className="mt-2 details-form details-form-right">
        <div className="">
          <div className="left-detailbox">
            <div className="details-box-inn d-flex justify-content-end position-absolute-icon">
              <div className="d-flex justify-content-end">
                <div className="btn-outerbox">
                  {(employeeData?.userData?.isMeetingOrganiser === true ||
                    employeeData?.userData?.isAdmin === true) &&
                  minute &&
                  minute.isApproved == false &&
                  actionData?.singleActionDetails?.actionStatus !==
                    "REASSIGNED" ? (
                    <div className="d-inline-block menu-dropdown custom-dropdown">
                      <ActionDropDownNew
                        minuteId={minute._id}
                        actionDetails={minute}
                        isFollowOnMeeting={true}
                        handleReopenActionModal={() => {
                          handleReopenActionModal(true, minute);
                        }}
                        handleApproveActionModal={() => {
                          handleApproveActionModal(true, minute);
                        }}
                        handleCancelActionModal={() => {
                          handleCancelAction(true, minute);
                        }}
                        handleReassignModal={() => {
                          handleReassignModal(minute);
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="form-group">
              <div className="row">
                <div className="col-md-4">
                  <label className="mb-1">Meeting Title</label>
                </div>
                <div className="col-md-7">
                  <Link
                    target={"_blank"}
                    to={`/view-meeting-details/${actionData?.singleActionDetails?.meetingDetail?._id}`}
                  >
                    <p
                      data-toggle="tooltip"
                      data-placement="left"
                      title="Go to Meeting Details"
                    >
                      {actionData?.singleActionDetails?.meetingDetail?.title
                        .charAt(0)
                        .toUpperCase() +
                        actionData?.singleActionDetails?.meetingDetail?.title
                          .slice(1)
                          .toLowerCase()}
                    </p>
                  </Link>
                </div>
              </div>
            </div>

            <div className="form-group">
              <div className="row">
                <div className="col-md-4">
                  <label className="mb-1">Agenda</label>
                </div>
                <div className="col-md-8">
                  <p>
                    {parse(
                      actionData?.singleActionDetails?.agendaDetail?.title
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="form-group">
              <div className="row">
                <div className="col-md-4">
                  <label className="mb-1">Held On</label>
                </div>
                <div className="col-md-4">
                  <p>
                    {
                      formatDateTimeFormat(
                        actionData?.singleActionDetails?.meetingDetail?.date
                      ).formattedDate
                    }
                  </p>
                </div>
              </div>
            </div>

            <div className="form-group">
              <div className="row">
                <div className="col-md-4">
                  <label className="mb-1">Action Title</label>
                </div>
                <div className="col-md-8">
                  <p>{actionData?.singleActionDetails?.title}</p>
                </div>
              </div>
            </div>
            {checkEmptyString(actionData?.singleActionDetails?.description) ===
              null ||
            checkEmptyString(actionData?.singleActionDetails?.description) ===
              " " ||
            checkEmptyString(actionData?.singleActionDetails?.description) ===
              undefined ? null : (
              <div className="form-group">
                <div className="row">
                  <div className="col-md-4">
                    <label className="mb-1">Action Description</label>
                  </div>
                  <div className="col-md-8">
                    <div className="text-editor">
                      {actionData?.singleActionDetails?.description
                        ? parse(
                            decryptWithAES(
                              actionData?.singleActionDetails?.description
                            )
                          )
                        : null}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="form-group">
              <div className="row">
                <div className="col-md-4">
                  <label className="mb-1">Action Due Date</label>
                </div>
                <div className="col-md-8">
                  <p>{actionData?.singleActionDetails?.mainDueDate}</p>
                </div>
              </div>
            </div>

            <div className="form-group">
              <div className="row">
                <div className="col-md-4">
                  <label className="mb-1">Action Completed Date</label>
                </div>
                <div className="col-md-8">
                  <p>
                    {actionData?.singleActionDetails?.isComplete
                      ? formatDateTimeFormat(
                          actionData?.singleActionDetails?.isCompleteDetails[
                            actionData?.singleActionDetails?.isCompleteDetails
                              ?.length - 1
                          ].dateTime
                        ).formattedDate
                      : "NA"}
                  </p>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="row">
                <div className="col-md-4">
                  <label className="mb-1">Priority</label>
                </div>
                <div className="col-md-8">
                  <p>
                    {actionData?.singleActionDetails?.priority
                      .charAt(0)
                      .toUpperCase() +
                      actionData?.singleActionDetails?.priority
                        .slice(1)
                        .toLowerCase()}
                  </p>
                </div>
              </div>
            </div>

            <div className="form-group">
              <div className="row">
                <div className="col-md-4">
                  <label className="mb-1">Assignee User(s)</label>
                </div>
                <div className="col-md-8">
                  {actionData?.singleActionDetails?.assignedUserDetail?.length >
                    0 && (
                    <div>
                      {actionData.singleActionDetails.assignedUserDetail.map(
                        (user, index) =>
                          user.name && <div key={index}>{user.name}</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {actionData?.singleActionDetails?.parentMinuteId ? (
              <div className="form-group">
                <div className="row">
                  <div className="col-md-4">
                    <label className="mb-1">Assigned Due Date</label>
                  </div>
                  <div className="col-md-8">
                    <p>{actionData?.singleActionDetails?.dueDate}</p>
                  </div>
                </div>
              </div>
            ) : null}

            {actionData?.singleActionDetails?.actionStatus ===
            "CANCELLED" ? null : (
              <div className="form-group">
                <div className="row">
                  <div className="col-md-4">
                    <div
                      className="d-flex align-items-center"
                      style={{ height: "100%" }}
                    >
                      <label className="mb-1">Delay Status</label>
                    </div>
                  </div>
                  <div className="col-md-8">
                    {actionData?.singleActionDetails?.isDelayed === true ? (
                      <>
                        <span className="badge delay-color bg-opacity-10 ">
                          Delayed
                        </span>
                        <p className="detail-date-time delay-status-before ">
                          {actionData?.singleActionDetails?.completionStatus}
                        </p>
                      </>
                    ) : (
                      <>
                        <span className="badge notDelay-color bg-opacity-10 ">
                          Not Delayed
                        </span>
                        <p className="detail-date-time delay-status-before ">
                          {actionData?.singleActionDetails?.completionStatus}
                        </p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className="form-group">
              <div className="row">
                <div className="col-md-4">
                  <label className="mb-1">Status</label>
                </div>
                <div className="col-md-8">
                  {actionData?.singleActionDetails?.actionStatus ===
                  "COMPLETED" ? (
                    <span className="badge completed-color bg-opacity-10 ">
                      Completed
                    </span>
                  ) : null}
                  {actionData?.singleActionDetails?.actionStatus ===
                  "REOPENED" ? (
                    <span className="badge reopened-color bg-opacity-10 ">
                      Reopened
                    </span>
                  ) : null}
                  {actionData?.singleActionDetails?.actionStatus ===
                  "APPROVED" ? (
                    <span className="badge approved-color bg-opacity-10 ">
                      Approved
                    </span>
                  ) : null}
               
                  {employeeData?.userData?.isAdmin === false &&
                  isMeetingOrganiser === false &&
                  actionData?.singleActionDetails?.actionStatus ===
                    "REQUESTFORREASSIGN" ? (
                    actionData?.singleActionDetails?.reassigneRequestDetails?.[
                      actionData?.singleActionDetails?.reassigneRequestDetails
                        .length - 1
                    ]?.userId?.toString() ===
                    employeeData?.userData?._id?.toString() ? (
                      <span className="badge forwardrequested-color bg-opacity-10">
                        Forward Requested
                      </span>
                    ) : (
                      <span className="badge pending-color bg-opacity-10">
                        Pending
                      </span>
                    )
                  ) : null}

                  {employeeData?.userData?.isAdmin === false &&
                  isMeetingOrganiser === false &&
                  actionData?.singleActionDetails?.actionStatus ===
                    "PENDING" ? (
                    <span className="badge pending-color bg-opacity-10 ">
                      Pending
                    </span>
                  ) : null}
                  {(employeeData?.userData?.isAdmin || isMeetingOrganiser) &&
                  actionData?.singleActionDetails?.actionStatus ===
                    "PENDING" ? (
                    <span className="badge pending-color bg-opacity-10 ">
                      Pending
                    </span>
                  ) : null}
                  {(employeeData.userData.isAdmin || isMeetingOrganiser) &&
                  actionData?.singleActionDetails?.actionStatus ===
                    "REQUESTFORREASSIGN" ? (
                    <span className="badge forwardrequested-color bg-opacity-10 ">
                      Forward Requested
                    </span>
                  ) : null}

                  {(employeeData.userData.isAdmin || isMeetingOrganiser) &&
                  actionData?.singleActionDetails?.actionStatus ===
                    "REASSIGNED" ? (
                    <span className="badge reassigned-color bg-opacity-10 ">
                      Forwarded
                    </span>
                  ) : null}

                  {!employeeData.userData.isAdmin &&
                  !isMeetingOrganiser &&
                  actionData?.singleActionDetails?.actionStatus ===
                    "REASSIGNED" ? (
                    <span className="badge reassigned-color bg-opacity-10 ">
                      Forwarded
                    </span>
                  ) : null}

                  {actionData?.singleActionDetails?.actionStatus ===
                  "CANCELLED" ? (
                    <span className="badge canceled-color bg-opacity-10 ">
                      Cancelled
                    </span>
                  ) : null}
                </div>
              </div>
            </div>

            <>
             

              {(actionData?.singleActionDetails?.actionStatus !==
                "REASSIGNED" &&
           
                actionData?.singleActionDetails?.isComplete === false &&
                actionData?.singleActionDetails?.isCancelled === false &&
                (actionData?.singleActionDetails?.assignedUserId.toString() ===
                  employeeData?.userData?._id?.toString() ||
                  employeeData?.userData?.isAdmin ||
                  isMeetingOrganiser ||
                  actionData?.singleActionDetails?.meetingDetail?.createdById.toString() ===
                    employeeData?.userData?._id?.toString())) ||
              (isRejectedUser === false &&
                actionData?.singleActionDetails?.actionStatus !== "COMPLETED" &&
                actionData?.singleActionDetails?.actionStatus !==
                  "REASSIGNED" &&
                actionData?.singleActionDetails?.isApproved === false &&
                actionData?.singleActionDetails?.isCancelled === false) ? (
                <>
                  <div className="minutes-border"></div>
                  <div className="form-group mb-0">
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        <label className="mb-1">Action</label>
                      </div>
                      <div className="col-md-8">
                        <div className="complete-check">
                          <input
                            className="form-check-input top0"
                            type="checkbox"
                            id="flexCheckDefault"
                            name="isComplete"
                            onChange={() => checkHandler(props.actionId)}
                            checked={
                              actionData?.singleActionDetails?.isComplete
                            }
                          />
                          <label>Mark as Completed</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}

              {actionData?.singleActionDetails?.actionStatus !== "REASSIGNED" &&
              (isUserFind?.length === 0 ||
                (isUserFind[isUserFind?.length - 1].isAccepted === false &&
                  isUserFind[isUserFind?.length - 1].isRejected === true)) &&
              actionData?.singleActionDetails?.isComplete === false &&
              actionData?.singleActionDetails?.isCancelled === false &&
              actionData?.singleActionDetails?.assignedUserId?.includes(
                employeeData?.userData?._id
              ) &&
              employeeData?.userData?.isAdmin === false ? (
                <button
                  className="add-btn Mom-btn mt-3"
                  type="button"
                  onClick={() => {
                    setActionId(props.actionId);
                    setIsRequestForReassignModalOpen(true);
                  }}
                >
                  <p>Request for Forward</p>
                </button>
              ) : null}
            </>
          </div>
        </div>
      </form>

      <RequestForReassignModal
        setIsModalOpen={setIsRequestForReassignModalOpen}
        isModalOpen={isRequestForReassignModalOpen}
        actionId={props.actionId}
      />
      <IsCompleteModal
        setIsModalOpen={setIsCompleteModalOpen}
        isModalOpen={isCompleteModalOpen}
        handleSubmit={handleUpdateIsComplete}
      />
      <ReopenActionModal
        meetingId={minuteDetails?.meetingId}
        minuteDetails={minuteDetails}
        IsReopenMinuteModal={isReopenMinuteModal}
        setIsReopenMinuteModal={setIsReopenMinuteModal}
        accessToken={accessToken}
        parentMeetingId={props.parentMeetingId}
        isCalledFromViewAction={true}
        actionId={props.actionId}
      />
      <CommonModal
        message={"Do you want to cancel the action ?"}
        title={"Cancel Action"}
        setIsModalOpen={setIsCloseModalOpen}
        isModalOpen={isCloseModalOpen}
        handleSubmit={submitCancelAction}
        buttonName={"Cancel"}
        isCalledFromOthers={true}
      />
      <ReassignModal
        setIsReassignModalOpen={setIsReassignModalOpen}
        isModalOpen={isReassignModalOpen}
        meetingData={meetingData}
        handleSubmit={handleReassign}
        actionData={actionDatas}
        meetingDate={actionDatas}
        attendData={actionDatas}
        isFromViewAction={true}
      />
    </>
  );
});

export default ViewActionDetails;
